import { type FC } from "react";
import { Route, Routes } from "react-router-dom";

import { useRootSelector } from "@ds/hooks";

import { selectCurrentUserProject } from "../settings/projects/redux/selectors/common-selectors";
import { AnalyticsMainPage } from "./analytics-main-page";

export const AnalyticsRouter: FC = () => {
  const shouldShowAnalyticsPage = !!useRootSelector(selectCurrentUserProject)?.dashboard_id;
  return <Routes>{shouldShowAnalyticsPage && <Route path="*" element={<AnalyticsMainPage />} />}</Routes>;
};
